import columns from './utils/columns'
import summaries from './utils/summaries'

const state = () => ({
  associationId: null,
  baseReportName: 'yield',
  subId: null,

  publisher: null,

  health: null,
  yield: null,
  programmatic: null,

  columns,
  summaries,

  programmaticViewStatus: null,
  isLoadingProgrammatic: false,
  didLoadProgrammaticFail: false,

  isLoadingPublisher: false,
  didLoadPublisherFail: false,
})

export default state
